{{ attributeName }} :<br />
<ces-value-change [detail]="detail()" [showActionText]="true" />
